import React from 'react';

import { DetailedIconTrophy } from '@zillow/constellation';
import { Paragraph } from '@zillow/constellation-10';

const ConfirmationThanks = () => (
  <>
    <DetailedIconTrophy />
    <Paragraph css={{ textStyle: 'heading-sm', marginBlock: '400' }}>
      This listing will be deactivated as of today.
    </Paragraph>
    <Paragraph>Your advertising period will be included on your next invoice.</Paragraph>
  </>
);

export default ConfirmationThanks;
